import { useNavigate } from "react-router-dom";
import { BasketIcon } from "@/components/icons/SvgIcons";
import { testAttrs } from "@/utils/testAttrs";

interface BasketButtonProps {
  to?: string;
  count?: number;
  text?: string;
  total?: string;
  className?: string;
  children?: React.ReactNode;
  onClick?: () => void;
  showIcon?: boolean;
  currencySymbol?: string;
  disabled?: boolean;
  testId?: string;
}

export function BasketButton({
  to,
  count,
  text = "Basket",
  total,
  className = "",
  children,
  onClick,
  showIcon = true,
  currencySymbol = "£",
  disabled = false,
  testId,
}: BasketButtonProps) {
  const navigate = useNavigate();

  const handleClick = () => {
    if (disabled) {
      return; // Do nothing when disabled
    }
    if (onClick) {
      onClick();
    }
    if (to) {
      navigate(to);
    }
  };

  const buttonContent = (
    <>
      {showIcon && (
        <div className="relative">
          <BasketIcon
            width={24}
            height={24}
            className="mr-3 text-white shrink-0"
          />
          {count !== undefined && (
            <span className="absolute -top-1 right-1.5 bg-dominos-red-bright text-white text-[10px] font-bold rounded-full w-4 h-4 flex items-center justify-center">
              {count}
            </span>
          )}
        </div>
      )}
      <span className="text-md uppercase px-8">{text}</span>

      {total && (
        <span className="bg-dominos-green-dark px-3 py-3 rounded-full text-sm" {...testAttrs({ "data-testid": "basket-button-total" })}>
          {currencySymbol}
          {total}
        </span>
      )}

      {children}
    </>
  );

  const buttonClasses = `flex z-1 items-center dominos-secondary bg-dominos-green text-white rounded-full pl-4 pr-1 py-1 hover:bg-dominos-green-dark transition-colors w-auto ${className}`;

  return (
    <button onClick={handleClick} className={buttonClasses} {...(testId ? testAttrs({ "data-testid": testId }) : {})}>
      {buttonContent}
    </button>
  );
}
